module.exports = __webpack_public_path__ + "img/ava-7.d32f5a30.png";